import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ScrollToTop } from "@/lib/seo";
import { ContentProvider } from "@/lib/content";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import HomePage from "@/pages/HomePage";
import GatewayPage from "@/pages/GatewayPage";
import EnergiaSolarPage from "@/pages/EnergiaSolarPage";
import CarregadoresPage from "@/pages/CarregadoresPage";
import CarregadorDetalhePage from "@/pages/CarregadorDetalhePage";
import SolucoesPage from "@/pages/SolucoesPage";
import ProjetoInstalacaoPage from "@/pages/ProjetoInstalacaoPage";
import PlataformaPage from "@/pages/PlataformaPage";
import SobrePage from "@/pages/SobrePage";
import ContatoPage from "@/pages/ContatoPage";
import SimulePage from "@/pages/SimulePage";
import ResponsabilidadesPage from "@/pages/ResponsabilidadesPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPage from "@/pages/admin/AdminPage";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ContentProvider>
        <div className="min-h-screen bg-[#FAFAF9] text-slate-900 overflow-x-clip">
          <SiteHeader />
          <main>
            <Routes>
              <Route path="/" element={<GatewayPage />} />
              <Route path="/hb-charger" element={<HomePage />} />
              <Route path="/energia-solar" element={<EnergiaSolarPage />} />
              <Route path="/carregadores" element={<CarregadoresPage />} />
              <Route path="/carregadores/:id" element={<CarregadorDetalhePage />} />
              <Route path="/solucoes" element={<SolucoesPage />} />
              <Route path="/projeto-instalacao" element={<ProjetoInstalacaoPage />} />
              <Route path="/plataforma" element={<PlataformaPage />} />
              <Route path="/sobre" element={<SobrePage />} />
              <Route path="/contato" element={<ContatoPage />} />
              <Route path="/simule" element={<SimulePage />} />
              <Route path="/responsabilidades-tecnicas" element={<ResponsabilidadesPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <SiteFooter />
          <FloatingWhatsApp />
          <Toaster position="top-center" richColors />
        </div>
      </ContentProvider>
    </BrowserRouter>
  );
}
